module.exports = __webpack_public_path__ + "static/img/ykshh_1.1864f8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/ykshh_1.jpg
// module id = cGjS
// module chunks = 15